import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";

const requests = {
    organisationsSearch: (config: AxiosRequestConfig) =>
        api.get(`/tools/organisations`, config),
};

export default requests;
